'use strict';

export { withDecay } from './decay';
//# sourceMappingURL=index.js.map